import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { GameStats } from '../components/GameStats';
import { GuessDistribution } from '../components/GuessDistribution';
import { useFiardleStats } from '../hooks/useFiardleStats';
import { useFiardleLeaderboard } from '../hooks/useFiardleLeaderboard';

export function FiardleStatsPage() {
  const { stats, loading: statsLoading } = useFiardleStats();
  const [sortBy, setSortBy] = useState('wins');
  const { entries, loading: lbLoading } = useFiardleLeaderboard(sortBy);

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-bold">Fiardle Stats</h1>

      {/* Personal Stats */}
      {statsLoading ? (
        <Skeleton className="h-24 w-full" />
      ) : stats ? (
        <div className="space-y-4">
          <GameStats
            gamesPlayed={stats.gamesPlayed}
            gamesWon={stats.gamesWon}
            currentStreak={stats.currentStreak}
            maxStreak={stats.maxStreak}
            winRate={stats.winRate}
          />
          <GuessDistribution distribution={stats.guessDistribution} />
        </div>
      ) : null}

      {/* Leaderboard */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Leaderboard</CardTitle>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="text-sm border rounded px-2 py-1"
              data-testid="sort-select"
            >
              <option value="wins">Most Wins</option>
              <option value="winRate">Win Rate</option>
              <option value="streak">Longest Streak</option>
            </select>
          </div>
        </CardHeader>
        <CardContent>
          {lbLoading ? (
            <Skeleton className="h-48 w-full" />
          ) : entries.length === 0 ? (
            <p className="text-muted-foreground text-center py-4">No entries yet</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="leaderboard-table">
                <thead>
                  <tr className="border-b text-left">
                    <th className="py-2 pr-4">#</th>
                    <th className="py-2 pr-4">Player</th>
                    <th className="py-2 pr-4 text-right">Won</th>
                    <th className="py-2 pr-4 text-right">Played</th>
                    <th className="py-2 pr-4 text-right">Win %</th>
                    <th className="py-2 text-right">Streak</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.map((entry, idx) => (
                    <tr key={entry.userId} className="border-b last:border-0">
                      <td className="py-2 pr-4 text-muted-foreground">{idx + 1}</td>
                      <td className="py-2 pr-4 font-medium">{entry.username || 'Anonymous'}</td>
                      <td className="py-2 pr-4 text-right">{entry.gamesWon}</td>
                      <td className="py-2 pr-4 text-right">{entry.gamesPlayed}</td>
                      <td className="py-2 pr-4 text-right">{Math.round(entry.winRate * 100)}%</td>
                      <td className="py-2 text-right">{entry.maxStreak}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
